const escape = (value: string) => value.replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]!));

export function reportInitials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  return (words.length > 1 ? [words[0], words[words.length - 1]] : words)
    .map(word => Array.from(word)[0]).join('').toLocaleUpperCase().slice(0, 4) || '—';
}

/** Native broken-image CSS handles failed URLs without scripts in the sandbox/PDF. */
export function reportImage(kind: 'brand-logo' | 'mast-photo' | 'company-logo' | 'contact-logo' | 'contact-photo', name: string, src?: string): string {
  const initials = escape(reportInitials(name));
  if (!src) return `<span class="${kind} report-image-fallback" aria-hidden="true">${initials}</span>`;
  return `<img class="${kind} report-image" alt="" aria-hidden="true" data-initials="${initials}" src="${escape(src)}">`;
}
